import { render, staticRenderFns } from "./HoverBtns.vue?vue&type=template&id=5dd53676&scoped=true"
import script from "./HoverBtns.vue?vue&type=script&lang=js"
export * from "./HoverBtns.vue?vue&type=script&lang=js"
import style0 from "./HoverBtns.vue?vue&type=style&index=0&id=5dd53676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd53676",
  null
  
)

export default component.exports